import { Text } from "@chakra-ui/react";
import React from "react";
import { Fade } from "react-awesome-reveal";
import GitHubCalendar from "react-github-calendar";
import styles from "../css/GtihubStat.module.css";
const GithubStat = () => {
  return (
    <div className={styles.gitBox}>
      <Fade bottom>
        <Text
          color="#E4002B"
          fontWeight={"bolder"}
          textAlign={"center"}
          mb={8}
          fontSize={{ base: "xl", md: "3xl" }}
        >
          Github Calender and Stats
        </Text>
        <div className={styles.Github}>
          <GitHubCalendar username="vicky160898" className="calender" />
        </div>
        <div className={styles.Github1}>
          <div>
          {/* <a
            href="https://github.com/vicky160898"
            rel="noreferrer"
            target="_blank"
          > */}
            <img
              alt="7oSkaaa's Github Stats"
              src="https://github-readme-stats.vercel.app/api?username=vicky160898&show_icons=true&count_private=true&theme=dark"
              height="192px"
            />
          {/* </a> */}
          </div>
          <div>
          {/* <a
            href="https://github.com/vicky160898"
            rel="noreferrer"
            target="_blank"
          > */}
          <img
            align="center"
            src="https://github-readme-streak-stats.herokuapp.com/?user=vicky160898&&theme=dark"
            alt="vicky160898"
          />
            {/* </a> */}
            </div>
        </div>
      </Fade>
    </div>
  );
};

export default GithubStat;
